import { ChartSettingsShowOptions } from './chart-settings-show-options.enum';

export const QuantityChartViewVariants = [
  {
    label: 'Bar chart',
    value: ChartSettingsShowOptions.Bar,
  },
  {
    label: 'Line chart',
    value: ChartSettingsShowOptions.Line,
  },
  {
    label: 'Area chart',
    value: ChartSettingsShowOptions.Area,
  },
];
